export default __webpack_public_path__ + "static/media/inactive6.031d5d55.svg";